<!--
 * @Author: Junjie
 * @Date: 2022-11-10 09:47:15
 * @LastEditTime: 2023-12-18 13:01:08
 * @email: 781433561@qq.com
 * @Description:
 * @FilePath: /iplus-iwt-fe/src/views/monitor/points/RealtimeData.vue
-->
<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper" v-if="!deviceData">
      <a-form @keyup.enter.native="searchQuery" layout="inline">
        <a-row :gutter="24">
          <a-col :lg="6" :md="6" :sm="24" :xl="6">
            <a-form-item label="供水流域">
              <j-dict-select-tag
                @change="searchQuery"
                dictCode="`iwt-wf`.dev_process,process_name,id"
                placeholder="请选择供水流域"
                v-model="queryParam.devProcessId"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="6" :md="6" :sm="24" :xl="6">
            <a-form-item label="设备">
              <j-search-select-tag
                @change="searchQuery"
                dict="`iwt-wf`.dev_list,dev_name,id,del_flag=0 order by sort asc"
                placeholder="请选择设备"
                v-model="queryParam.devId"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="6" :md="6" :sm="24" :xl="6">
            <a-form-item label="测点名称">
              <a-input allowClear placeholder="请输入测点名称" v-model="queryParam.pointName"></a-input>
            </a-form-item>
          </a-col>
          <a-col :lg="6" :md="6" :sm="24" :xl="6">
            <a-form-item label="点号">
              <a-input allowClear placeholder="请输入点号" v-model="queryParam.pointCode"></a-input>
            </a-form-item>
          </a-col>
          <a-col :lg="6" :md="6" :sm="24" :xl="6">
            <a-form-item label="位号">
              <a-input allowClear placeholder="请输入位号" v-model="queryParam.pointTag"></a-input>
            </a-form-item>
          </a-col>

          <a-col :lg="6" :md="6" :sm="24" :xl="6">
            <a-form-item label="数据类型">
              <j-dict-select-tag
                @change="searchQuery"
                dictCode="point_data_type"
                placeholder="请选择数据类型"
                type="list"
                v-model="queryParam.dataType"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="4" :md="4" :sm="24" :xl="4">
            <span class="table-page-search-submitButtons" style="float: left;overflow: hidden;">
              <a-button @click="searchQuery" icon="search" type="primary">查询</a-button>
              <a-button @click="searchReset" icon="reload" style="margin-left: 8px" type="primary">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->
    <!-- table区域-begin -->
    <div>
      <a-table
        :columns="columns"
        :customRow="customRowRender"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :scroll="{ x: true }"
        @change="handleTableChange"
        bordered
        class="j-table-force-nowrap"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <template slot="valueColor" slot-scope="text, record">
          <div :style="getValueColStyle(record)">{{ getValueColText(text, record) }}</div>
        </template>
        <span slot="action" slot-scope="text, record">
          <a @click="handleDetail(record)">查看详情</a>
          <a-divider type="vertical" />
          <a @click="dataHistory(record)">历史数据</a>
        </span>
      </a-table>
    </div>
    <iot-model-points-modal :deviceData="deviceData" @ok="modalFormOk" ref="modalForm"></iot-model-points-modal>
    <points-line-chart-modal ref="pointsDataLineModal"></points-line-chart-modal>
  </a-card>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { getAction, httpAction } from '@/api/manage'
  import PointsLineChartModal from '@views/monitor/datas/modules/PointsLineChartModal'
  import IotModelPointsModal from './modules/IotModelPointsModal'
  import { filterMultiDictText } from '@/components/dict/JDictSelectUtil'
  import { validatenull, validatenotnull } from '@/utils/validate'
  import moment from 'dayjs'

  export default {
    name: 'RealtimeData',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
      PointsLineChartModal,
      IotModelPointsModal
    },
    props: {
      deviceData: {
        type: Object,
        default: () => { }
      },
      idType: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        description: '实时数据',
        // 表头
        columns: [
          {
            title: '测点名称',
            align: 'center',
            dataIndex: 'pointName',
            ellipsis: true,
            width: '150px',
            sorter: true
          },
          {
            title: '设备',
            align: 'center',
            dataIndex: 'devId_dictText',
            sorter: true
          },
          {
            title: '点号',
            align: 'center',
            dataIndex: 'pointCode',
            sorter: true
          },
          {
            title: '当前值时间戳',
            align: 'center',
            dataIndex: 'timeSeriesDetail.timeStamp',
            customRender: function (text) {
              return !text ? '' : text.length > 19 ? text.substr(0, 19) : text
            }
          },
          {
            title: '当前值',
            align: 'right',
            dataIndex: 'timeSeriesDetail.value'
            // scopedSlots: { customRender: 'valueColor' }
          },
          {
            title: '计量单位',
            align: 'center',
            dataIndex: 'dataUnit'
          },
          {
            title: '数据类型',
            align: 'center',
            dataIndex: 'dataType_dictText',
            sorter: true
          },

          {
            title: '数据来源',
            align: 'center',
            dataIndex: 'dataSource_dictText'
          },
          // {
          //   title: '量程上限',
          //   align: 'center',
          //   dataIndex: 'toprange'
          // },
          // {
          //   title: '量程下限',
          //   align: 'center',
          //   dataIndex: 'botrange'
          // },
          {
            title: '操作',
            dataIndex: 'action',
            align: 'center',
            fixed: 'right',
            width: 167,
            scopedSlots: { customRender: 'action' }
          }
        ],
        ipagination: {
          current: 1,
          pageSize: 50
          //   pageSizeOptions: ['50', '100', '200'],
          //   showTotal: (total, range) => {
          //     return range[0] + '-' + range[1] + ' 共' + total + '条'
          //   },
          //   showQuickJumper: true,
          //   showSizeChanger: true,
          //   total: 0
        },
        conditionModalVisibal: false,
        url: {
          list: '/monitor/iotModelPoints/list',
          queryById: '/device/devWorkingConditions/queryById'
        },
        dictOptions: {},
        superFieldList: [],
        disableMixinCreated: true,
        runCondition: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 8 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        modalFormShow: false,
        colorList: {}
      }
    },

    async created () {
      await this.loadColor()
      this.getSuperFieldList()
      if (this.idType == '') {
        this.loadData()
      }
      // 初始化websocket
      this.initWebSocket()
    },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
      }
    },
    methods: {
      loadData (arg) {
        if (!this.url.list) {
          this.$message.error('请设置url.list属性!')
          return
        }
        // 加载数据 若传入参数1则加载第一页的内容
        if (arg === 1) {
          this.ipagination.current = 1
        }
        var params = this.getQueryParams() // 查询条件
        if (params.pointCode) {
          params.pointCode = `*${params.pointCode}*`
        }
        params.dataSource = 'sensor'
        this.loading = true
        getAction(this.url.list, params)
          .then(res => {
            if (res.success) {
              this.dataSource = res.result.records || res.result
              if (res.result.total) {
                this.ipagination.total = res.result.total
              } else {
                this.ipagination.total = 0
              }
            } else {
              this.$message.warning(res.message)
            }
          })
          .finally(() => {
            this.loading = false
          })
      },
      handleAdd: function () {
        const ref = this.hasDeviceId ? 'modalFormDetail' : 'modalForm'
        this.$refs[ref].add()
        this.$refs[ref].title = '新增'
        this.$refs[ref].disableSubmit = false
      },
      handleCopy (record) {
        this.$refs['modalForm'].copy(record)
        this.$refs['modalForm'].title = '另存为'
        this.$refs['modalForm'].disableSubmit = false
      },
      handleDetail (record) {
        // const ref = this.hasDeviceId ? 'modalFormDetail' : 'modalForm'
        const ref = 'modalForm'
        this.$refs[ref].edit(record)
        this.$refs[ref].title = '详情'
        this.$refs[ref].disableSubmit = true
      },
      getSuperFieldList () {
        let fieldList = []
        fieldList.push({
          type: 'sel_search',
          value: 'devId',
          text: '设备',
          dictTable: '`iwt-wf`.dev_list',
          dictText: 'dev_name',
          dictCode: 'id'
        })
        fieldList.push({
          type: 'int',
          value: 'devProcessId',
          text: '供水流域',
          dictCode: '`iwt-wf`.dev_process,process_name,id'
        })
        fieldList.push({ type: 'string', value: 'hubCode', text: '网关编码', dictCode: '' })
        fieldList.push({ type: 'string', value: 'pointName', text: '测点名称', dictCode: '' })
        fieldList.push({ type: 'string', value: 'pointCode', text: '点号', dictCode: '' })
        fieldList.push({ type: 'string', value: 'pointTag', text: '位号', dictCode: '' })
        fieldList.push({ type: 'string', value: 'dataType', text: '数据类型', dictCode: 'point_data_type' })
        fieldList.push({ type: 'string', value: 'dataUnit', text: '计量单位', dictCode: '' })
        fieldList.push({ type: 'string', value: 'dataSource', text: '数据来源', dictCode: 'point_data_source' })
        fieldList.push({ type: 'string', value: 'dataCategory', text: '业务属性', dictCode: '' })
        fieldList.push({ type: 'int', value: 'readonly', text: '是否只读', dictCode: 'yn' })
        fieldList.push({ type: 'BigDecimal', value: 'toprange', text: '量程上限', dictCode: '' })
        fieldList.push({ type: 'BigDecimal', value: 'botrange', text: '量程下限', dictCode: '' })
        fieldList.push({ type: 'BigDecimal', value: 'multi', text: '倍率', dictCode: '' })
        fieldList.push({ type: 'BigDecimal', value: 'shift', text: '偏移', dictCode: '' })
        fieldList.push({ type: 'int', value: 'trend', text: '变化趋势', dictCode: 'point_data_trend' })
        fieldList.push({ type: 'int', value: 'tenantId', text: '租户id', dictCode: '' })
        fieldList.push({ type: 'string', value: 'orgId', text: '公司id', dictCode: '' })
        fieldList.push({ type: 'int', value: 'delFlag', text: '删除状态', dictCode: '' })
        this.superFieldList = fieldList
      },
      checkDataSource () {
        if (validatenull(this.dataSource) || this.dataSource.length == 0) {
          this.$message.warning('请先配置相关测点')
        } else {
          let params = { id: this.deviceData.id }
          getAction(this.url.queryById, params).then(res => {
            if (res.success) {
              this.runCondition = res.result
              this.conditionModalVisibal = true
            } else {
              if (res.message == '未找到对应数据') {
                this.$message.warning('未找到对应数据' + ',请配置运行条件！')
                this.runCondition = {}
                this.conditionModalVisibal = true
              } else {
                this.$message.warning(res.message)
              }
            }
          })
        }
      },
      dataHistory (record) {
        const pointCode = record.pointCode
        this.$refs.pointsDataLineModal.show(pointCode)
      },
      initWebSocket: function () {
        var url = window._CONFIG['realtimeWsURL']
        this.websock = new WebSocket(url)
        this.websock.onopen = this.websocketonopen
        this.websock.onerror = this.websocketonerror
        this.websock.onmessage = this.websocketonmessage
        this.websock.onclose = this.websocketclose
      },
      websocketonmessage: function (e) {
        var data = JSON.parse(e.data)
        // 处理订阅信息
        if (data.topic == 'realtime') {
          const realData = data.payload
          realData.forEach(_point => {
            this.dataSource.forEach(_row => {
              if (_row.pointCode.toLocaleUpperCase() === _point.tag.toLocaleUpperCase()) {
                _row.timeSeriesDetail = {
                  value: _point.value,
                  time: _point.time,
                  timeStamp: _point.time
                }
              }
            })
          })
        }
      },
      async loadColor () {
        const colorData = await getAction('/custom/category/childListByPCode', {
          pCode: 'A08A01'
        })

        if (colorData.success) {
          const color = colorData.result
            .map(({ name, cusProp1 }) => ({
              name,
              cusProp1
            }))
            .reduce((pre, cur) => {
              pre[cur.name] = cur.cusProp1
              return pre
            }, {})

          this.colorList = color
        }
      },
      getValueColStyle (row) {
        let style = {}
        if (row.pointCode.toLocaleUpperCase().includes('_ALARM')) {
          style['color'] = '#fff'
          style['background-color'] = row.timeSeriesDetail.value == 1 ? this.colorList.stop : this.colorList.run
        } else if (row.pointCode.toLocaleUpperCase().endsWith('RUN')) {
          style['color'] = '#fff'
          style['background-color'] = row.timeSeriesDetail.value == 1 ? this.colorList.run : this.colorList.stop
        } else if (row.pointCode.toLocaleUpperCase().endsWith('STATE')) {
          style['color'] = '#fff'
          style['background-color'] = row.timeSeriesDetail.value == 1 ? this.colorList.run : this.colorList.stop
        }
        return style
      },
      getValueColText (text, row) {
        if (!row.timeSeriesDetail) {
          return '--'
        }
        if (row.dataType === 'BOOL') {
          if (row.pointCode.toLocaleUpperCase().includes('_ALARM')) {
            text = row.timeSeriesDetail.value == 1 ? '报警' : '正常'
          } else if (row.pointCode.toLocaleUpperCase().endsWith('RUN')) {
            text = row.timeSeriesDetail.value == 1 ? '运行' : '停止'
          } else if (row.pointCode.toLocaleUpperCase().endsWith('STATE')) {
            text = row.timeSeriesDetail.value == 1 ? '运行' : '停止'
          }
        } else if (row.dataType === 'int') {
          text = parseInt(row.timeSeriesDetail.value, 10)
        }
        return text
      }
    }
  }
</script>
<style scoped>

  @import '~@assets/less/common.less';

</style>
